import React from "react";
import { observer } from "mobx-react";
import { CountryViewStore } from "../../store";
import { CountryViewForm } from "./CountryViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type CountryViewProps = {
  countryViewStore: CountryViewStore;
};

export const CountryView: React.FC<CountryViewProps> = observer(
  ({ countryViewStore }) => {
    return (
      <div>
        <CountryViewForm
          name_es={countryViewStore.name_esValue}
          name_en={countryViewStore.name_enValue}
          name_pt={countryViewStore.name_ptValue}
          code={countryViewStore.codeValue}
          currency={countryViewStore.currencyValue}
          demonym_es={countryViewStore.demonym_esValue}
          demonym_en={countryViewStore.demonym_enValue}
          demonym_pt={countryViewStore.demonym_ptValue}
          onPrint={(handlePrint: () => void) =>
            countryViewStore.printCountry(handlePrint)
          }
          onCancel={() => countryViewStore.cancelCountry()}
          onEdit={
            countryViewStore.isEditEnabled
              ? () => countryViewStore.editCountry()
              : undefined
          }
        />
        <ErrorDialog
          open={countryViewStore.errorDialogOpened}
          title={countryViewStore.errorTitle}
          description={countryViewStore.errorDescription}
          onClose={() => countryViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
